import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ICadDraftHeaderResponse, IGetDeclarationResponse } from '../models/api';

@Injectable()
export class DeclarationViewService {

  private readonly currentDeclarationSubject = new BehaviorSubject<IGetDeclarationResponse>(null);
  private readonly currentAdjusmentDeclarationSubject = new BehaviorSubject<ICadDraftHeaderResponse>(null);
  private readonly baseVersionUnderCorrection = new BehaviorSubject<boolean>(false);

  public get onViewDeclarationChange$(): Observable<IGetDeclarationResponse> {
    return this.currentDeclarationSubject.asObservable();
  }

  public setCurrentDeclaration(declaration: IGetDeclarationResponse) {
    this.currentDeclarationSubject.next(declaration);
  }

  public get onViewDeclarationAdjustChange$(): Observable<ICadDraftHeaderResponse> {
    return this.currentAdjusmentDeclarationSubject.asObservable();
  }

  public setCurrentDeclarationAdjust(declaration: ICadDraftHeaderResponse) {
    this.currentAdjusmentDeclarationSubject.next(declaration);
  }

  public setFirstVersionCadUnderCorrection(underCorrection: boolean){
    this.baseVersionUnderCorrection.next(underCorrection);
  }

  public get getFirstVersionUnderCorrection(): Observable<boolean> {
    return this.baseVersionUnderCorrection.asObservable();
  }
}
